<template>
  <el-form-item
    :label="label"
    class="email"
    :prop="prop"
    :rules="rules"
  >
    <el-autocomplete
      v-model="email"
      :clearable="true"
      :maxlength="200"
      :placeholder="placeholder"
      :disabled="disabled"
      :fetch-suggestions="querySearch"
      :trigger-on-focus="false"
      :autofocus="autofocus"
    />
  </el-form-item>
</template>

<script>
import AutocompleteFilter from '@/mixins/AutocompleteFilter.vue'
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    AutocompleteFilter,
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: 'メールアドレス'
    },
    prop: {
      type: String,
      default: 'email'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeholder: this.searchCond ? '前方一致' : '最大200文字'
    }
  },
  computed: {
    email: {
      get () {
        return this.value
      },
      set (email) {
        this.$emit('input', email)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'blur'))
          }
          if (!this.searchCond) {
            rules.push(this.validatorEmail(this.label, 'blur'))
          }
        }
        return rules
      }
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.user-name {
  ::v-deep .el-form-item__content {
    width: 18em;
  }
}
</style>
